module.exports = __webpack_public_path__ + "media/images/qr_code_pix-103b3e6319b7101b5584a9f8af566e8f.jpeg";